import { ICD_CODE_VERSION } from '../../../viewmodels'
import { ICDCode } from '../logic'

export const generateICDCodes = (selectedIcdCodes: ICDCode[]) => {
  return {
    version: ICD_CODE_VERSION,
    codes: selectedIcdCodes.map((icd) => icd.code) ?? [],
  }
}
